// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  fetchPost
} from './api/http.js'
import {
  Pagination,
  Message
} from 'element-ui';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import MetaInfo from 'vue-meta-info'

Vue.use(Pagination);
Vue.use(Viewer);
Vue.use(MetaInfo);
Vue.config.productionTip = false;
Vue.prototype.$post = fetchPost;
Vue.prototype.$imgBaseUrl = 'http://wxsmjphoto.wanjiejixie.com'
Vue.prototype.$message = Message;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js